<div *ngIf="doneLoading">
  <section>
    <h1 class="header-1">{{ 'check-user.welcome' | translate }} {{ eventName}} </h1>
    <p>{{ eventDescription }}</p>
    <h1 class="header-1"> {{ 'check-user.title' | translate }}</h1>
  </section>
  <section *ngIf="state === 'can-register-reserve'">
    <p>
      {{ eventFullMessage }}
    </p>
  </section>

  <section *ngIf="state === 'can-register' || state === 'can-register-reserve'" class="form">
    <form #userCheckForm="ngForm" (ngSubmit)="OnSubmit(userCheckForm)">
      <div class="row">
        <div class="col col-1-4">
          <label class="label" for="email">{{ 'check-user.email' | translate }} *</label>
        </div>
        <div class="col">
          <input id="email" name="emailAddress" type="email" email required ngModel #email="ngModel" (keyup)="onLeaveEmailAddress()"/>
          <div class="error-summary" *ngIf="(userCheckForm.submitted && email.errors != null) || userAlreadyRegistered">
            <div class="error" *ngIf="email.errors && email.errors.required">{{ 'check-user.email-required' | translate }}</div>
            <div class="error" *ngIf="email.errors && email.errors.email">{{ 'check-user.email-invalid' | translate }}</div>
            <div class="error" *ngIf="userAlreadyRegistered">{{ 'check-user.already-registered' | translate }}</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col col-1-4"></div>
        <div class="col">
          <app-captcha name="captcha" (verified)="afterChallengeSuccess(userCheckForm, $event);" ngModel></app-captcha>
          <button type="submit" [disabled]="(loader.IsLoading | async)">{{ 'check-user.submit' | translate }}</button>
        </div>
      </div>
    </form>
  </section>
  <section *ngIf="state === 'event-is-full'">
    <p>
      {{ eventFullMessage }}
    </p>
  </section>
  <section *ngIf="state === 'event-is-closed'">
    <p>
      {{ eventClosedMessage }}
    </p>
  </section>
</div>
